import { render } from "./tree.vue?vue&type=template&id=76d72ccc&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"

import "./tree.vue?vue&type=style&index=0&id=76d72ccc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-76d72ccc"

export default script